module.exports = __webpack_public_path__ + "static/media/akropolis.8677a911.svg";